export default {
  backendUrl: null,
  frontendUrl: null,
}